import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconCloudy: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_1856_570)">
        <path
          d="M81.1756 52.4182L74.9422 52.2671L74.7911 46.0338C74.4606 33.4916 63.5806 23.301 50.5 23.301C46.8544 23.301 43.3411 24.0944 40.1583 25.5488C34.9922 27.9099 30.7328 31.9899 28.3339 37.2316L26.8606 40.4521L23.3567 40.9716C15.6406 42.1427 9.60556 48.036 8.28333 55.2516C8.11333 56.2244 8 57.216 8 58.236C8 67.8694 16.1694 75.6988 26.2089 75.6988H80.845C87.5411 75.6988 93 70.476 93 64.0538C93.0094 57.7921 87.7017 52.5788 81.1756 52.4182Z"
          fill="#D2E0FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1856_570">
          <rect
            width="85"
            height="85"
            fill="white"
            transform="translate(8 7)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default WeatherIconCloudy
